if(typeof {"type":"remote","url":"/api/restful/app/config"} === 'undefined') { var e = new Error("Cannot find module '{\"type\":\"remote\",\"url\":\"/api/restful/app/config\"}'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = {"type":"remote","url":"/api/restful/app/config"};